import Base from './Base';
import merge from 'lodash/merge';

const defaults = {
  settings: {
    fields: [],
  },
  strings: {
    formPrompt: 'Prompt',
    formFooter: 'Footer',
  },
}

export default class CompanyEvent extends Base {
  get settings() {
    return merge({}, defaults.settings, this.metadata.settings);
  }

  get strings() {
    return merge({}, defaults.strings, this.metadata.strings);
  }

}